import { useTranslation } from 'react-i18next'

import { PageHeader } from '@/components/ui/PageHeader'

import { AnalyticsDisplay } from './components/AnalyticsDisplay'
import { AnalyticsFilters } from './components/AnalyticsFilters'

export default function AnalyticsPage() {
  const { t } = useTranslation()

  return (
    <div className="p-5 space-y-5">
      <PageHeader
        title={t('nav.analytics', 'Analytics')}
        subtitle={t('analytics.subtitle', 'Driver performance and reports analysis')}
      />

      <AnalyticsFilters />
      <AnalyticsDisplay />
    </div>
  )
}
